// NOTE: This is a version of the Dropdown component from the @scripts/react package.
// Copied it here because the rendering of the menu items was not working as expected.

// TODO: Integrate this back into the @scripts/react package.

import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { twClassNames } from "@scripts/react/helpers/twClassNames";

interface DropdownMenuProps<T extends object> {
    items: T[];
    selectedItem: T;
    onSelectItem: (item: T) => void;
    getItemLabel: (item: T) => string;
    getItemKey: (item: T) => string | number;
    getLeftContent?: (item: T) => React.ReactNode;
    getRightContent?: (item: T) => React.ReactNode;
    getItemClassName?: (item: T) => string | undefined;
    buttonClassName?: string;
    menuItemsClassName?: string;
    menuItemClassName?: string;
    customMenuButton?: React.ReactNode;
    stayOpenAfterSelection?: boolean;
    disabled?: boolean;
}

export function DropdownMenu<T extends object>({
    items,
    selectedItem,
    onSelectItem,
    getItemLabel,
    getItemKey,
    getLeftContent,
    getRightContent,
    getItemClassName,
    menuItemsClassName = "",
    // right-0 top-full mt-1 w-32
    menuItemClassName,
    buttonClassName = "btn2 secondary",
    customMenuButton,
    stayOpenAfterSelection = false,
    disabled = false
}: DropdownMenuProps<T>) {
    return (
        <Menu as="div" className="headless-menu relative">
            {customMenuButton ? (
                <Menu.Button
                    className={twClassNames("btn2", buttonClassName)}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    disabled={disabled}
                >
                    {customMenuButton}
                </Menu.Button>
            ) : (
                <Menu.Button
                    className={twClassNames("btn2", buttonClassName)}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    disabled={disabled}
                >
                    {getItemLabel(selectedItem)}
                    <i className="fas fa-chevron-down"></i>
                </Menu.Button>
            )}
            <Transition
                as={Fragment}
                enter="transition duration-100 ease-out"
                enterFrom="transform scale-95 opacity-0"
                enterTo="transform scale-100 opacity-100"
                leave="transition duration-75 ease-out"
                leaveFrom="transform scale-100 opacity-100"
                leaveTo="transform scale-95 opacity-0"
            >
                <Menu.Items
                    className={twClassNames("menu-container !gap-0", menuItemsClassName)}
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    {items.map((item) => (
                        <Menu.Item key={getItemKey(item)}>
                            {({ active }) => (
                                <button
                                    className={twClassNames(
                                        "menu-item",
                                        menuItemClassName,
                                        getItemClassName && getItemClassName(item),
                                        active ? "active" : "inactive"
                                    )}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (stayOpenAfterSelection) {
                                            e.preventDefault();
                                        }
                                        onSelectItem(item);
                                    }}
                                >
                                    {getLeftContent && getLeftContent(item)}
                                    <span className="flex-1 text-left">{getItemLabel(item)}</span>
                                    {getRightContent && getRightContent(item)}
                                </button>
                            )}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Transition>
        </Menu>
    );
}
